import { Article } from '../components/Layout'
import { H1, P, Callout } from '../components/DocComponents'

export function StubPage({ title, summary }: { title: string; summary: string }) {
  return (
    <Article>
      <H1>{title}</H1>
      <P>{summary}</P>
      <Callout type="note">Full documentation for this section is coming soon.</Callout>
    </Article>
  )
}
